import { createSlice } from "@reduxjs/toolkit";
import { fetchLogin } from "../actions/loginAction";
import { REHYDRATE } from "redux-persist";

const initialState = {
  data: {
    id: 0,
    name: "",
    email: "",
    group_id: "",
  },
  isLoading: false,
  error: false,
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    token: (state, action) => {
      state.data = action.payload;
    },
    login: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLogin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLogin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchLogin.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(REHYDRATE, (state) => {
      const { data } = state;
      state.isLoading = false;
      state.data = data;
    });
  },
});

export const { login } = loginSlice.actions;

export default loginSlice.reducer;
